export const MESLEKLER = ['alp', 'akinci', 'kam', 'kargici'] as const
export type Meslek = (typeof MESLEKLER)[number]

export const DURUSLAR = [
  'kilic', 'balta',    // Alp
  'ok', 'bicak',       // Akıncı
  'buyu', 'sifa',      // Kam
  'tirpan', 'cirit',   // Kargıcı
] as const
export type Durus = (typeof DURUSLAR)[number]

export type Saf = 'on' | 'arka'
export type HasarTuru = 'fiziksel' | 'ruh'
export type Cinsiyet = 'erkek' | 'disi'

export const BUDUNLAR = ['oguz', 'kipcak', 'pecenek'] as const
export type Budun = (typeof BUDUNLAR)[number]

export const CERI_TURLERI = ['piyade', 'atli', 'okcu', 'kusatmaci'] as const
export type CeriTuru = (typeof CERI_TURLERI)[number]

/** Her mesleğin silah çifti. Sıra anlamlıdır: [A duruşu, B duruşu]. */
const MESLEK_DURUSLARI: Record<Meslek, readonly [Durus, Durus]> = {
  alp: ['kilic', 'balta'],
  akinci: ['ok', 'bicak'],
  kam: ['buyu', 'sifa'],
  kargici: ['tirpan', 'cirit'],
}

export function meslegeGoreDuruslar(meslek: Meslek): readonly [Durus, Durus] {
  return MESLEK_DURUSLARI[meslek]
}

/** Duruş, birimin hangi safta duracağını belirler. */
export const DURUS_SAFI: Record<Durus, Saf> = {
  kilic: 'on',   balta: 'on',
  ok: 'arka',    bicak: 'on',
  buyu: 'arka',  sifa: 'arka',
  tirpan: 'on',  cirit: 'arka',
}

/**
 * Duruşun verdiği hasar türü.
 * Kargıcı/Tırpan'ın "zırhı yok sayar" özelliği buradan doğar: ruh hasarı
 * zırha değil ruh direncine bakar, ayrı bir kural gerekmez.
 */
export const DURUS_HASAR_TURU: Record<Durus, HasarTuru> = {
  kilic: 'fiziksel',  balta: 'fiziksel',
  ok: 'fiziksel',     bicak: 'fiziksel',
  buyu: 'ruh',        sifa: 'ruh',
  tirpan: 'ruh',      cirit: 'fiziksel',
}

/** Duruş değişince saf değiştiren meslekler ceza alır. */
export function safDegistirirMi(meslek: Meslek): boolean {
  const [a, b] = MESLEK_DURUSLARI[meslek]
  return DURUS_SAFI[a] !== DURUS_SAFI[b]
}
